import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const css = ".ispui-dropdown-content{display:var(--ispui-dropdown-content-display, flex);overflow:var(--ispui-dropdown-content-overflow, hidden);min-height:var(--ispui-dropdown-content-min-height, 50px);max-height:var(--ispui-dropdown-content-max-height, inherit);padding:var(--ispui-dropdown-content-padding, 20px)}.ispui-dropdown-popup_has-cross .ispui-dropdown-content{padding:var(--ispui-dropdown-content-padding, 20px 50px 20px 20px)}.ispui-dropdown-popup_has-cross ispui-dropdown-header+.ispui-dropdown-content{padding:var(--ispui-dropdown-content-padding, 20px 20px 20px 20px)}.ispui-dropdown-content__wrapper{overflow-y:auto;max-height:inherit;padding-right:var(--ispui-dropdown-content-pr, 20px);scrollbar-color:var(--ispui-dropdown-scroll-indicator-color, var(--isp-text-main)) var(--ispui-dropdown-scroll-background-color, var(--isp-background-additional));scrollbar-width:thin;}.ispui-dropdown-content__wrapper::-webkit-scrollbar,.ispui-dropdown-content__wrapper::-webkit-scrollbar-track,.ispui-dropdown-content__wrapper::-webkit-scrollbar-thumb{width:var(--ispui-dropdown-scroll-indicator-width, 7px);height:var(--ispui-dropdown-scroll-indicator-height, 7px);border-radius:var(--ispui-dropdown-scrollborder-radius, 10px)}.ispui-dropdown-content__wrapper::-webkit-scrollbar{background:var(--ispui-dropdown-scroll-background-color, var(--isp-background-additional))}.ispui-dropdown-content__wrapper::-webkit-scrollbar-thumb{background:var(--ispui-dropdown-scroll-indicator-color, var(--isp-text-main))}.ispui-dropdown-content__wrapper::-webkit-scrollbar-button{display:none}";

const ISPUIDropdownContent = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
  }
  render() {
    return (h(Host, { class: "ispui-dropdown-content" }, h("div", { class: "ispui-dropdown-content__wrapper" }, h("slot", null))));
  }
  static get style() { return css; }
}, [4, "ispui-dropdown-content"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["ispui-dropdown-content"];
  components.forEach(tagName => { switch (tagName) {
    case "ispui-dropdown-content":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ISPUIDropdownContent);
      }
      break;
  } });
}

const IspuiDropdownContent = ISPUIDropdownContent;
const defineCustomElement = defineCustomElement$1;

export { IspuiDropdownContent, defineCustomElement };
